

class Session {
  id: string
  createdAt: string
  updatedAt: string
  accountId: string
  userId: string
  sessionDate: string
  duration: number

  constructor(data: any) {
    this.id = data.id
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.accountId = data.accountId
    this.userId = data.userId
    this.sessionDate = data.date ?? ""
    this.duration = data.duration ?? 0
  }
}

export default Session